import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="swipe-container"
export default class extends Controller {
  static targets = ["body", "actions"]
  static values = {
    open: { type: Boolean, default: false },
  }

  toggle() {
    if (this.openValue) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.bodyTarget.style.right = `${this.actionsWidth}px`
    this.openValue = true
  }

  close() {
    this.bodyTarget.style.right = null
    this.openValue = false
  }

  get actionsWidth() {
    return this.actionsTarget.offsetWidth
  }
}
